import { GroupedOption } from './models/option.model';

export function sortGroupedOptions(options: GroupedOption[]): GroupedOption[] {
  options.sort((a, b) => a.title.localeCompare(b.title));
  options.forEach(group => {
    group.options.sort((a, b) => a.label.localeCompare(b.label));
  });

  return options;
}
